/**
 * Define the redux persist storage Id
 *
 * @type {String}
 */
export const APP_PERSIST_ID = 'Mineralstore';
